import { FeedbackButton } from "./FeedbackButton";
import { handleLinkClick } from "../lib/router";
import { useIntroStore } from "../state/introStore";

/**
 * A small footer under the game (GRA-153), linking to the three static pages,
 * plus the feedback trigger, which moved here from the header so the header
 * stays down to the wordmark, the mode switcher, and the active mode's stats.
 * Deliberately its own component rather than living inside LoopShell or
 * AppHeader: it sits below every Loop's view in App.tsx, not inside the
 * game's own layout, and neither of those files' layout is this ticket's to
 * change. Below the fold on mobile by design; returning players still land
 * straight on the game.
 */
export function Footer() {
  // The first-visit intro is otherwise a one-time dialog with no way
  // back: a player who clicked through it on their first load had no door to
  // what the three modes are. It sits with the static pages because that is
  // what it is, an explanation, not a game control.
  const showIntro = useIntroStore((s) => s.show);

  return (
    // Below `sm` the links keep to one centred line ("about the data" shortens
    // to "data", the gaps tighten) with the credit centred under them, so the
    // footer is two short lines on a phone rather than three.
    <footer aria-label="site pages" className="relative mt-auto px-4 py-3 sm:py-4">
      <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs text-muted sm:gap-x-4">
        <a
          href="/how-to-play"
          onClick={handleLinkClick("/how-to-play")}
          className="hover:text-accent"
        >
          how to play
        </a>
        <a
          href="/data"
          onClick={handleLinkClick("/data")}
          aria-label="about the data"
          className="hover:text-accent"
        >
          <span className="hidden sm:inline">about the </span>data
        </a>
        <a href="/learn" onClick={handleLinkClick("/learn")} className="hover:text-accent">
          learn
        </a>
        <a
          href="/packs/pullbacks"
          onClick={handleLinkClick("/packs/pullbacks")}
          className="hover:text-accent"
        >
          packs
        </a>
        <a href="/privacy" onClick={handleLinkClick("/privacy")} className="hover:text-accent">
          privacy
        </a>
        <button type="button" onClick={showIntro} className="hover:text-accent">
          intro
        </button>
        <FeedbackButton className="hover:text-accent" />
      </div>
      <a
        href="https://grasshopperlabs.co.uk/"
        target="_blank"
        rel="noopener noreferrer"
        className="mt-2 block text-center text-[10px] text-dim/50 sm:text-right sm:text-xs hover:text-accent sm:absolute sm:right-4 sm:top-1/2 sm:mt-0 sm:-translate-y-1/2"
      >
        Built by Grasshopper Labs
      </a>
    </footer>
  );
}
